import React from 'react';
import {
  RACModal,
  RACButton,
  makeStyles,
  Typography,
} from '@rentacenter/racstrap';

export const useStyles = makeStyles((theme: any) => ({
  dialogContent: {
    textAlign: 'center',
    margin: `2rem 0 1rem`,
    height: '20%',
    overflow: 'visible',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    fontWeight: 'bold',
    fontSize: theme.typography.pxToRem(16),
  },
  errorText: {
    backgroundColor: '#FF0000',
  },
  dialogActions: {
    justifyContent: 'flex-end',
    position: 'sticky',
    bottom: 0,
  },

  barcodeClass: {
    padding: '0px',
    margin: '0px',
    marginTop: '0px',
  },
  column: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    justifyContent: 'space-between',
    marginTop: theme.typography.pxToRem(8),
  },
  group: {
    display: 'flex',
    gap: 8,
    maxHeight: theme.typography.pxToRem(50),
  },
  dialogRoot: {
    height: '100%',
    '& .MuiPaper-rounded': {
      borderRadius: theme.typography.pxToRem(12),
    },
    '& .MuiDialog-paperScrollPaper': {
      width: '43%',
      minHeight: theme.typography.pxToRem(230),
      minWidth: theme.typography.pxToRem(300),
    },
    '& .MuiDialogTitle-root': {
      display: 'none',
    },
    '& .MuiTypography-h5': {
      fontSize: theme.typography.pxToRem(20),
      fontWeight: 500,
      lineHeight: theme.typography.pxToRem(30),
    },
    '& .MuiDialogActions-root': {
      justifyContent: 'center',
    },
  },
  contentHeight: {
    height: '30%',
    overflow: 'scroll',
  },
  confirmSpan: {
    marginTop: '0.75rem',
  },
}));
export interface ReceiptNotAvailableModalProps {
  onResolve: (type: string) => void;
  onClose: () => void;
}

export const ReceiptNotAvailableModal = ({
  onClose,
}: ReceiptNotAvailableModalProps) => {
  const classes = useStyles();

  return (
    <RACModal
      isOpen
      classes={{
        dialogContent: classes.dialogContent,
        dialog: classes.dialogRoot,
      }}
      maxWidth="lg"
      title={''}
      content={
        <>
          <span></span>
          <span className={classes.confirmSpan}>
            Receipt has not been saved for this purchase order.
          </span>

          <div style={{ textAlign: 'center' }}>
            <div style={{ width: 320, margin: 'auto' }}></div>
          </div>
        </>
      }
      onClose={onClose}
      buttons={
        <>
          <div className={classes.group}>
            <div className={classes.column}>
              <span
                style={{
                  padding: '0px',
                  paddingLeft: '0px',
                  marginTop: '0px',
                  position: 'relative',
                  top: '-40px',
                }}
              >
                <Typography
                  variant="body1"
                  style={{ padding: '0px', marginTop: '0px' }}
                >
                  <RACButton
                    style={{
                      marginLeft: '40px',
                      position: 'relative',
                    }}
                    variant="contained"
                    color="primary"
                    onClick={() => onClose()}
                  >
                    OK
                  </RACButton>
                </Typography>
              </span>
            </div>
          </div>
        </>
      }
    />
  );
};
